import { Component } from 'react';

/**
 * Failure isolation (Phase 00 guardrail): a crash inside any Premium component
 * must never blank an existing screen. Children are replaced by nothing (or an
 * optional quiet fallback) and the rest of the page keeps working.
 */
export class PremiumBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.warn('[premium] component isolated after error:', error?.message);
  }

  render() {
    if (this.state.failed) return this.props.fallback ?? null;
    return this.props.children;
  }
}

export default PremiumBoundary;
